import type { ReactNode } from 'react';
import type { IconName } from '../engine/types';
import { cx } from '../utils/classnames';
import { Icon } from './Icon';

export interface SegmentOption<T extends string | number> {
  value: T;
  label: ReactNode;
  icon?: IconName;
}

interface SegmentedControlProps<T extends string | number> {
  options: ReadonlyArray<SegmentOption<T>>;
  value: T;
  onChange: (value: T) => void;
  ariaLabel: string;
  block?: boolean;
}

export function SegmentedControl<T extends string | number>({
  options,
  value,
  onChange,
  ariaLabel,
  block,
}: SegmentedControlProps<T>) {
  return (
    <div className={cx('cv-segmented', block && 'cv-segmented--block')} role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={String(option.value)}
          type="button"
          className="cv-segmented__option"
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.icon ? <Icon name={option.icon} size={16} /> : null}
          {option.label}
        </button>
      ))}
    </div>
  );
}
